import { amountValidation, ColorOptions, required, Text, TextInputNewProps } from '@jfs/ui-new'
import { TextInputNew } from '../../components/AdminInputs'
import { Toggle } from './Toggle'

const textStyle = {
  fontFamily: 'jiotype-medium',
  fontSize: 12,
  color: 'PRIMARY_GREY' as ColorOptions,
}

const textInputStyle = {
  fontSize: 14,
  color: 'BLACK_21',
  placeholderTextColor: 'PRIMARY_GREY',
  borderColor: 'PRIMARY_GREY',
  borderRadius: 4,
  padding: 8,
} as TextInputNewProps
export const liabilityFormData = (isEditable: boolean) => {
  return [
    {
      formItems: [
        {
          horizontalComps: [
            {
              fieldName: 'label2',
              displayName: 'label2',
              ComponentName: Text,
              title: 'Allow Liability',
              ...textStyle,
            },
            {
              fieldName: 'allowLiability',
              ComponentName: Toggle,
              disabled: !isEditable,
              validationSchema: required,
            },
          ],
        },
        {
          horizontalComps: [
            {
              fieldName: 'label3',
              displayName: 'label3',
              ComponentName: Text,
              title: 'Liability Limit',
              ...textStyle,
            },
            {
              fieldName: 'liabilityLimit',
              ComponentName: TextInputNew,
              editable: isEditable,
              placeholder: 'Liability Limit in Rupees',
              validationSchema: amountValidation,
              ...textInputStyle,
            },
          ],
          dependency: ['allowLiability', true],
        },
      ],
      horizontalFlex: 1,
      onSubmit: () => {
        return 'end'
      },
    },
  ]
}
